import React, { useMemo, useState } from "react";

import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { useQuery } from "@tanstack/react-query";
import { GetUserAgeGroupCount } from "../../../Api/report";
import { ErrorToast } from "../../../Utils/SweetAlert";
import FilterSidebar from "../../../Components/FilterSidebar";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const UserAgeGroupTab = () => {
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filters, setFilters] = useState({
        preset: "all",
        type: "",
        startDate: null,
        endDate: null,
    });

    const { data: reportData, isFetching: loading } = useQuery({
        queryKey: ["get-user-age-group-count", filters],
        queryFn: () => {
            const params = {
                type: filters.type || "",
                startDate: filters.startDate || "",
                endDate: filters.endDate || "",
            };
            return GetUserAgeGroupCount(params);
        },
        throwOnError: (error) => {
            ErrorToast(error?.response?.data?.message || "Server Error.");
        },
    });

    const data = reportData?.data || [];

    const chartData = useMemo(() => {
        return {
            labels: data.map(item => item.label),
            datasets: [
                {
                    label: "User Count",
                    data: data.map(item => item.count),
                    backgroundColor: "#AD5ADC",
                    borderRadius: 8,
                },
            ],
        };
    }, [data]);

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: "bottom",
            },
        },
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0
                }
            },
        },
    };

    return (
        <div className="reports-tab-content">
            <div className="row mb-4">
                <div className="col d-flex justify-content-end align-items-start pt-2">
                    <button
                        type="button"
                        className={`subscription-filter-trigger action-btn ${isFilterOpen ? 'active' : ''} h-auto py-2`}
                        onClick={() => setIsFilterOpen(true)}
                    >
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
                            <line x1="4" y1="6" x2="20" y2="6"></line>
                            <line x1="4" y1="12" x2="20" y2="12"></line>
                            <line x1="4" y1="18" x2="20" y2="18"></line>
                        </svg>
                        Filters
                    </button>
                    <FilterSidebar
                        open={isFilterOpen}
                        onClose={() => setIsFilterOpen(false)}
                        initialFilters={filters}
                        onApply={(values) => setFilters(values)}
                        onReset={() => setFilters({ preset: "all", type: "", startDate: null, endDate: null })}
                        moduleType="reports"
                        tabType="reports"
                    />
                </div>
            </div>

            <div className="card flex-fill border-card mb-3">
                <div className="card-header dashboard-chat-heading p-2">
                    <h5 className="card-title text-black fw-bold fs-4 pl-2">User Age Group Overview</h5>
                </div>
                <div className="card-body" style={{ height: '60vh' }}>
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                            <div className="spinner-border loader-theme" role="status" />
                        </div>
                    ) : (
                        <Bar options={options} data={chartData || { labels: [], datasets: [] }} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default UserAgeGroupTab;
